import { selector } from 'recoil'
import type { ChataiConversation, ChataiLog } from '~/graphql'
import type { Message } from '~/states/atoms/ChatAI'
import { chataiLogsPagesState } from '~/states/atoms/ChatAI'
import { chataiGenerateTitleLoadingsState } from '~/states/atoms/ChatAI'
import {
  chataiConversationMessagesState,
  chataiConversationsPagesState,
  chataiCreateConversationIsLoadingState,
} from '~/states/atoms/ChatAI'

export type Conversation = {
  loading: boolean
} & ChataiConversation

export const chataiConversationsState = selector<Conversation[]>({
  key: 'ChataiConversations',
  get: ({ get }) => {
    const set = new Set<string>()
    // 会話リストページ
    const pages = get(chataiConversationsPagesState) ?? []
    // タイトル生成ローディング
    const loadings = get(chataiGenerateTitleLoadingsState)

    const messages = pages.reduce<Conversation[]>((acc, page) => {
      page.items
        .filter((item) => !set.has(item.id))
        .forEach((item) => {
          set.add(item.id)
          const loading = loadings.get(item.id) ?? false
          acc.push({ ...item, loading })
        })
      return acc
    }, [])

    return messages
  },
})

export const chataiLogsState = selector<ChataiLog[]>({
  key: 'ChataiLogs',
  get: ({ get }) => {
    const set = new Set<string>()
    // 会話リストページ
    const pages = get(chataiLogsPagesState) ?? []

    const logs = pages.reduce<ChataiLog[]>((acc, page) => {
      page.items
        .filter((item) => !set.has(item.id))
        .forEach((item) => {
          set.add(item.id)
          acc.push(item)
        })
      return acc
    }, [])

    return logs
  },
})

export const chataiConversationStreamState = selector<Message[]>({
  key: 'ChataiConversationStream',
  get: ({ get }) => {
    return get(chataiConversationMessagesState) ?? []
  },
  set: ({ get, set }, newValue) => {
    // const conversationId = get(chataiConversationIdState)
    // 新しい会話かどうか
    // const isNewChat = conversationId === null
    const conversation = get(chataiConversationMessagesState)
    // 会話作成中かどうか
    const isLoading = get(chataiCreateConversationIsLoadingState)

    if (!Array.isArray(newValue)) return

    /**
     * 会話が作成中で、データがセットされる場合は、APIより会話が応答されてきたときです。
     * この場合は、会話スタックを最後のユーザーメッセージと、応答されてきた会話の最初のユーザーメッセージは
     * 同一のものなので、会話スタックにひもづけるように結合します。
     */
    if (isLoading) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      const newConversation = conversation.concat(newValue)
      set(chataiConversationMessagesState, newConversation)
    } else {
      /**
       * 会話が作成中ではないときは、会話をリクエストする前です。
       * この場合は、会話スタックに単純に結合します。
       */
      set(chataiConversationMessagesState, conversation.concat(newValue))
    }
  },
})
